import { Component, ViewChild, ElementRef } from '@angular/core';
import { NavController,  ViewController, Slides, ItemSliding, Item, AlertController, Searchbar,} from 'ionic-angular';

import { UserMyRadiant as User, TrackingAsset } from '@providers/index';
import { Nav, NavParams, MenuController, Events, ModalController  } from 'ionic-angular';

import { RepositoryMyRadiant, HelperMyRadiant, ApiMyRadiant} from '@providers/index';
import { CalendarResult } from 'ion2-calendar';
import { PhotoViewer } from '@ionic-native/photo-viewer';
import { File } from '@ionic-native/file';
import { FileTransfer, FileTransferObject } from '@ionic-native/file-transfer';
import { Utility } from '@providers/resources/utility';
import { TabsPage } from '@pages/dashboard';
import { DrawerState } from 'ion-bottom-drawer';
import { DetailEmployeeActivity, DetailIdle, Tracking, AppActivity } from "@pages/activity";
import { cmpDepartmentList } from '@src/components/departmentList/cmp';
import { Storage } from '@ionic/storage';
import { Tracker } from '@providers/activity';
import leaflet from 'leaflet';
import * as mapboxgl from 'mapbox-gl';
import { Geolocation } from '@ionic-native/geolocation';
import { HistoryTracking } from '../history/page';
@Component({
  selector: 'detail-tracking-activity',
  templateUrl: 'page.html'
})
export class DetailTrackingActivity {

  berita:any = '';
  loading : any;
  asset:any;
  data = {
    employee:[],
    employee_filter : [],
    selected:{
      department:[]
    },
    user:{
      lat : 0,
      lng : 0,
    },
    style : 'mapbox://styles/mapbox/outdoors-v9',
  };
  state = {
    skeleton : true,
    employee_selected : this.userApi.data.user_name,
  };

  today = this.helper.getToday();
  parameter : any = {
    search : '',
  }
  map = mapboxgl.Map;
  marker: any = [];
  drawerOptions: any;
  fileTransfer: FileTransferObject = this.transfer.create();
  // @ViewChild('widgetSearch') private searchBar: Searchbar;
  // @ViewChild('map') mapContainer: ElementRef;
  // map: any;

  constructor(
    private api           : ApiMyRadiant,
    public userApi        : User,
    public alertCtrl      : AlertController,
    public nav            : Nav,
    public utility        : Utility,
    public repositoryProvider : RepositoryMyRadiant,
    public helper         : HelperMyRadiant,
    public viewCtrl       : ViewController,
    private photoViewer   : PhotoViewer,
    private file          : File,
    private transfer      : FileTransfer,
    private events        : Events,
    private modalCtrl     : ModalController,
    private storage       : Storage,
    public trackerProvider   : Tracker,
    private geolocation       : Geolocation,
    private navParams   : NavParams,
  ) {
      this.drawerOptions = {
        handleHeight: 0,
        thresholdFromBottom: 200,
        thresholdFromTop: 200,
        bounceBack: false,
        has_event_panup: true,
        event_panup : () => {
          document.getElementById('area-asset').style.height = "calc(100vh - 200px)";
        },
        has_event_pandown:true,
        event_pandown : () => {
          document.getElementById('area-asset').style.height = "calc(40vh - 120px)";
        },
      };
      this.asset = this.navParams.get('data');
      mapboxgl.accessToken = this.userApi.tokenMapbox;
    }

    ionViewDidEnter() {
      let me = this;
      this.loadmap();
    }
   
    loadmap() {
      this.map = new mapboxgl.Map({
        container: 'map-tracking',
        style: this.data.style,
        attributionControl:false,
        zoom: 15,
        center: [this.asset['longitude'],this.asset['latitude']],
      });
      this.map.addControl(new mapboxgl.NavigationControl());
      this.map.addControl(new mapboxgl.GeolocateControl({
        positionOptions: {
        enableHighAccuracy: true,
        zoom:0
        },
        trackUserLocation: true
      }));
      this.map.on('load',() => {
        let el = document.createElement('div');
        el.className = 'marker-orange';
         let mark =  new mapboxgl.Marker(el)
        .setLngLat([this.asset['longitude'],this.asset['latitude']])
        .addTo(this.map);
        this.marker.push(mark);
        this.map.flyTo({
          center:[this.asset['longitude'],this.asset['latitude']],
          zoom: 17,
          speed: 0.9,
          curve: 1,
          easing(t) {
            return t;
          },
          essential: true 
        })
      });    
    }
  
  backMyRadiant(evt){
    this.nav.setRoot(TabsPage,{tabIndex:1});
    this.events.publish('modul:myradiant');
  }

  historyAsset(data){
    this.nav.setRoot(HistoryTracking,{data:this.asset});
  }

  backButton(){
    this.nav.setRoot(AppActivity,{tabIndex:1});
  }

  showListDepartment(){
    let me = this;
  }

  
}



// WEBPACK FOOTER //
// ./src/pages/activity/tracking/detail/page.ts